var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEscalator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240 128C204.654 128 176 156.652 176 192V297.174L303.367 185.729C300.172 153.369 273.197 128 240 128ZM240 96C266.525 95.9 288 74.455 288 48C288 21.543 266.525 0.1 240 0C213.475 0.1 192 21.543 192 48C192 74.455 213.475 95.9 240 96ZM560 128H448C428.625 128 409.906 135.031 395.312 147.797L161.938 352H80C35.812 352 0 387.812 0 432S35.812 512 80 512H192C211.375 512 230.094 504.969 244.688 492.203L478.062 288H560C604.188 288 640 252.188 640 208S604.188 128 560 128Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscalator);
export default __webpack_public_path__ + "static/media/escalator.b1dd039c31098a67658b43d61487b9bf.svg";
export { ForwardRef as ReactComponent };